import type { PageHeaderProps } from './PageHeader.types';

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  teReoTitle,
  variant,
  headingElement = 'h1',
}) => {
  const CustomTitle = `${headingElement}` as keyof JSX.IntrinsicElements;
  const classes = variant
    ? `page-header page-header--${variant}`
    : 'page-header';

  return (
    <div className={classes}>
      <div className="page-header__text container">
        {teReoTitle && (
          <p
            className="page-header__title page-header__title--tereo h1 h1--light"
            data-testid="PageHeader__TeReoTitle"
            data-aos="fade-in"
          >
            {teReoTitle}
          </p>
        )}

        <CustomTitle
          className="page-header__title h1"
          data-testid="PageHeader__Title"
          data-aos="fade-in"
          data-aos-delay="100"
        >
          {title}
        </CustomTitle>
      </div>
    </div>
  );
};

export default PageHeader;
